import React, { useEffect, useState } from "react";
import "./Compliance.scss";
import { PieChart } from "@mui/x-charts/PieChart";
import Box from "@mui/material/Box";
import { complianceStatusIcons } from "./complianceConstants";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import CompliancePopup from "./CompliancePopup";
import Chip from '@material-ui/core/Chip';
import { withStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from 'react-redux';
import { GET_COMPLIANCE_STATE_DATA, SET_PROCESSED_DATA } from './complianceConstants';
import ComplianceScore from "./ComplianceScore";
import { processComplianceDataUtils } from "./ComplianceUtils";
import Page_Loader from "../../assets/vizr_images/page_loader.gif";

const StandardChip = withStyles((theme) => ({
  root: {
    fontSize: 22,
    margin: 10,
  },
}))(Chip);

function ComplianceDashboard({ selectedState }) {
  const [dashBoardData, setDashBoardData] = useState([]);
  const [headerData, setHeaderData] = useState([]);
  const [selectedCard, setSelectedCard] = useState(null);
  const history = useHistory();
  const dispatch = useDispatch();
  const selectedSiteFromStore = useSelector(
    (state) => state.ComplianceReducer.selectedSite
  );
  const complianceLoader = useSelector(
    (state) => state.ComplianceReducer.complianceLoader
  );
  const complianceStateData = useSelector(
    (state) => state.ComplianceReducer.complianceStateData
  );
  const complianceData = complianceStateData?.standardRules;
  const standards = complianceStateData?.selectedStandards;
  
  const reloadData = () => {
    if (selectedSiteFromStore && selectedSiteFromStore.name) {
      dispatch({ type: GET_COMPLIANCE_STATE_DATA, payload: { selectedSite: selectedSiteFromStore } });
    }
  };
  useEffect(() => {
    reloadData();
  }, [selectedSiteFromStore]);


  const processComplianceData = () => {
    const { processedData, headerData } = processComplianceDataUtils(complianceData);
    // Update state
    setDashBoardData(processedData);
    setHeaderData(headerData);
    dispatch({ type: SET_PROCESSED_DATA, payload: { processedData: processedData } });
  };

  useEffect(() => {
    processComplianceData();
  }, [complianceData]);

  const handleViewAllClick = () => {
    history.push("/gov/complianceReport");
  };

  const ComplianceStandards = ({ standards }) => {
    return (
      <div className="boxContainer standards">
        <div className="box-border">
          <div>
            <p className="score-title">Standards:</p>
          </div>
          <div className="align-center score-value">
            {standards?.map((standard, index) => (
              <StandardChip
                key={index}
                classes={"score-value"}
                label={standard}
              />
            ))}
          </div>
        </div>
      </div>
    );
  };

  const renderComplianceMiddleHeader = () => {
    return (
      <>
        <div className="scoreCardTitle">Score Breakdowns</div>
        <div className="complianceChildContainer disp-flex">
          <ComplianceScore textColor="black" headerData={headerData} />
          <ComplianceStandards standards={standards} />
        </div>
      </>
    );
  };

  const renderScoreBreakDownTitle = () => {
    return (
      <div className="score-breakdowns-container">
        <div className="scoreCardSubtitle">
          Category Scores.
        </div>
      </div>
    );
  };

  const renderCards = () => {
    return (
      <div className="cards-container">
        {dashBoardData.map((card) => (
          <div
            key={card.id}
            className={card.hasAlert ? `alert-blink card ${card.status}` : `card ${card.status}`}
            onClick={() => card.pieChartData && setSelectedCard(card)}
          >
            <div className="card-header">
              {card.pieChartData ? (
                <div className="compliancePieContainer">
                  <Box>
                    <PieChart
                      series={card.pieChartData}
                      colors={card.color}
                      width={200}
                      height={150}
                      sx={{
                        "& .MuiPieArc-root": {
                          stroke: "black",
                          strokeWidth: 1.5,
                        },
                      }}
                      margin={{ left: 5 }}
                      slotProps={{
                        legend: { hidden: true },
                      }}
                    />
                  </Box>
                </div>
              ) : (
                <div>No Data</div>
              )}
              <div className="complianceStatusContainer">
                <img
                  src={complianceStatusIcons[card.status]}
                  alt={card.status}
                  className="status-indicator"
                />
                <div className="date">{card.date}</div>
              </div>
            </div>
            <div className="card-body">
              <div className="navigate-icon-container">
                <h3 className="card-title">{card.title}</h3>
                <div className="navigateIcon">
                  <NavigateNextIcon className="navigate-next" />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  if (dashBoardData.length === 0 || headerData.length === 0) {
    return (
      <div>
        <div>No Data</div>
      </div>
    );
  }

  if (complianceLoader) {
    return <div className="loader-container">
      <img src={Page_Loader} alt="Loading..." />
    </div>;
  } else {
    return (
      <>
        {selectedCard && <div className="backdrop" />}
        <div className="scrollable">
          {renderComplianceMiddleHeader()}
          <div className="complianceChildContainer scoreCards">
            {renderScoreBreakDownTitle()}
            <div className="cardsParentContainer">
              <CompliancePopup
                isOpen={!!selectedCard}
                onClose={() => setSelectedCard(null)}
                selectedCard={selectedCard}
              />
              {renderCards()}
              <button className="view-all-btn" onClick={() => handleViewAllClick()}>
                View Report
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }

}

export default ComplianceDashboard;
